import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * LoadingScreen Component
 * Full-screen modern loading indicator; shows "Loading" text only.
 */
const LoadingScreen: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        gap: 3,
      }}
    >
      <CircularProgress
        size={40}
        thickness={3}
        sx={{
          color: 'primary.main',
        }}
      />
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          fontWeight: 500,
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          fontSize: '0.75rem',
        }}
      >
        Loading
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
